export default "__VITE_ASSET__DbN1iHwn__"